import { getChameleonWebVersion } from '../../common/chameleon-version'
import { getHostAppVersion } from '../../common/host-app-version'
import { GOTO_SHELL_VERSION } from '../../common/version'
import { getExtensionsManager } from '../../extensions/extensions-manager'
import type { ExtensionMetadata } from '../../extensions/metadata-definition'
import { getLaunchDarklyFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'

export class MetaService {
  getAppVersion(): string {
    return getHostAppVersion()
  }

  getShellVersion(): string {
    return GOTO_SHELL_VERSION
  }

  getChameleonWebVersion(): string {
    return getChameleonWebVersion()
  }

  getUseExtensions(): boolean {
    return !!getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_USE_EXTENSIONS)
  }

  getExtensions(): ExtensionMetadata[] {
    return getExtensionsManager()
      .getExtensions()
      .map(extension => extension.getMetadata())
  }
}
